define(
    'libs/respond/respond',[
        'jquery',

        'libs/inject-style/inject-style',
        'libs/modernizr/modernizr'
    ],

    function($, injector) {
        /**
        * Used to handle breakpoints
        *
        * @class Respond
        **/
        var Respond = (function() {
            var
            /**
            * Contains all breakpoints
            *
            * @property {Array} breakpoints
            **/
            breakpoints = [],

            /**
            * Contains all generated media queries to detect breakpoints
            *
            * @property {Array} media queries
            */
            mediaQueries = [],

            /**
            * Time to wait before applying breakpoints after resize in ms
            *
            * @property {Integer} RESIZE_DELAY
            * @default 200
            **/
            RESIZE_DELAY = 200,

            /**
             * Time to wait before reapplying media queries in ms
             *
             * @property {Integer} RESET_MEDIA_QUERIES_DELAY
             * @default 50
             */
            RESET_MEDIA_QUERIES_DELAY = 50,

            /**
            * Breakpoint detection element ID
            *
            * @property {String} breakpointElementID
            */
            breakpointElementID = 'breakpoint-check',

            /**
             * Timeout before reapplying media queries
             *
             * @property {Number} resetMediaQueriesTimeout
             */
            resetMediaQueriesTimeout;

            function Respond() {}

            /**
            * Retrieve the transition event name
            *
            * @method _getTransitionEventName
            * @private
            * @return {String}
            */
            function _getTransitionEventName() {
                var transEndEventNames = {
                        'WebkitTransition' : 'webkitTransitionEnd',// Saf 6, Android Browser
                        'MozTransition'    : 'transitionend',      // only for FF < 15
                        'transition'       : 'transitionend'       // IE10, Opera, Chrome, FF 15+, Saf 7+
                    },
                    transEndEventName = transEndEventNames[ Modernizr.prefixed('transition') ];

                return transEndEventName;
            }

            /**
            * Check if a media query with given values already exist
            *
            * @method _mediaQueryExist
            * @private
            * @return {Boolean}
            */
            function _mediaQueryExist(min, max) {
                var breakpoint,
                    isMinFound = false,
                    isMaxFound = false;

                for (var i = 0; i < mediaQueries.length; i++) {
                    breakpoint = mediaQueries[i];

                    if (!isMinFound && (breakpoint.min === min || breakpoint.max === min)) {
                        isMinFound = true;
                    }

                    if (!isMaxFound && (breakpoint.min === max || breakpoint.max === max)) {
                        isMaxFound = true;
                    }

                    if (isMinFound && isMaxFound) {
                        return true;
                    }
                }

                return false;
            }

            /**
             * Reset styles of breakpointElement according to new breakpoints
             *
             * @method _resetMediaQueries
             * @private
             * @return {Void}
             */
            function _resetMediaQueries() {
                // remove previous rules
                for (var i = 0; i < mediaQueries.length; i++) {
                    if (mediaQueries[i].ref) {
                        injector.removeMediaQuery(mediaQueries[i].ref);
                    }
                }

                // generate list of breakpoint boundaries
                var breakpointsBoundaries = [];
                for(var i = 0; i < breakpoints.length; i++){
                    if (breakpointsBoundaries.indexOf(breakpoints[i].min) === -1) {
                        breakpointsBoundaries.push(breakpoints[i].min)
                    }

                    if (breakpointsBoundaries.indexOf(breakpoints[i].max) === -1) {
                        breakpointsBoundaries.push(breakpoints[i].max)
                    }
                }
                breakpointsBoundaries.sort(function(a, b){ return a - b; });

                // generate new media queries
                mediaQueries = [];
                var min, max, rule;
                for(var i = 0; i < breakpointsBoundaries.length; i++) {
                    min = breakpointsBoundaries[i];
                    max = i + 1 < breakpointsBoundaries.length ? breakpointsBoundaries[i + 1] : null;
                    rule = injector.createRule('html #' + breakpointElementID, {
                            'left': mediaQueries.length + 1
                        })

                    mediaQueries.push({
                        min: min,
                        max: max,
                        ref: injector.addMediaQuery(min, max, [rule])
                    });
                }
            }

            /**
            * Add action at breakpoint
            *
            * @method atBreakpoint
            * @param {Integer} minimum Window width to run "run"
            * @param {Integer} maximum Window width to run "undo", if 0 there will be no upper limit
            * @param {Function} run Run when breakpoint is met
            * @param {Function} undo Runs when breakpoint is no longer met, should undo what
            * ever "run" did
            **/
            Respond.prototype.atBreakpoint = function(minimum, maximum, run, undo) {
                breakpoints.push({
                    min: minimum,
                    max: maximum,
                    run: run,
                    undo: undo,
                    active: false
                });

                if (!_mediaQueryExist(minimum, maximum)) {
                    window.clearTimeout(resetMediaQueriesTimeout);
                    resetMediaQueriesTimeout = setTimeout(function() {
                        _resetMediaQueries();
                    }, RESET_MEDIA_QUERIES_DELAY);
                }
            };

            /**
            * Calls appropriate action on all breakpoints registered
            *
            * @method run
            * @return {Void}
            **/
             Respond.prototype.run = function() {
                function windowWidth() {
                    var e = window, a = 'inner';
                    if (!('innerWidth' in window )) {
                        a = 'client';
                        e = document.documentElement || document.body;
                    }
                    return e[ a+'Width' ];
                }

                var width = windowWidth();
                var breakpoint;

                for (var i = 0; i < breakpoints.length; i++) {
                    breakpoint = breakpoints[i];

                    if (breakpoint.min <= width && (breakpoint.max >= width || breakpoint.max === 0)) {
                        if (!breakpoint.active) {
                            breakpoint.run.call();
                            breakpoints[i].active = true;
                        }
                    } else {
                        if (breakpoint.active) {
                            if (breakpoint.undo !== undefined) {
                                breakpoint.undo.call();
                            }

                            breakpoints[i].active = false;
                        }
                    }
                }
            };

            /**
            * Watches the resize event on window and runs "run" when it's triggered.
            * However, the functions is not run until resize-event hasn't been retriggered
            * for RESIZE_DELAY ms to prevent unneccessary function calls
            *
            * @method watchResize
            * @return {Void}
            **/
            Respond.prototype.watchResize = function() {
                var _this = this,
                    breakpointTimeout,
                    transEndEventName = _getTransitionEventName();

                if (transEndEventName) {
                    if ($('#' + breakpointElementID).length === 0) {
                        $('body').append('<div id="' + breakpointElementID + '"></div>');

                        injector.addRule('#' + breakpointElementID, {
                            'position': 'absolute',
                            'left': 0,
                            '-webkit-transition': '.001s left',
                            '-moz-transition': '.001s left',
                            'transition': '.001s left'
                        });
                    }

                    $('#' + breakpointElementID).on(transEndEventName, _this.run);
                }
                else {
                    $(window).resize(function() {
                        window.clearTimeout(breakpointTimeout);

                        breakpointTimeout = setTimeout(function() {
                            _this.run();
                        }, RESIZE_DELAY);
                    });
                }
            };

            /**
            * Runs given function only if criteria is met, does not monitor resize.
            *
            * @method ifMet
            * @param {Integer} min Minimum viewport width
            * @param {Integer} max Maximum viewport width
            * @param {Function} callback
            * @return {Void}
            **/
            Respond.prototype.ifMet = function(min, max, callback) {
                var width = (isOldIE() ? 1800 : $(window).width());

                if (min <= width && (max >= width || max === 0)) {
                    callback.call();
                }
            };

            return Respond;
        })();

        // We return an instance of respond to avoid duplicates
        return new Respond();
    }
);

